package er.prateek.crossly.persistence

import com.russhwolf.settings.Settings

private const val KEY_DAY = "reveal_day_key"
private const val KEY_REVEALS_TODAY = "reveal_reveals_today"

class SettingsRevealPrefsStore(
    private val settings: Settings,
) : RevealPrefsStore {

    override fun load(): RevealFrequencyState {
        val defaults = RevealFrequencyState()
        return RevealFrequencyState(
            dayKey = settings.getString(KEY_DAY, defaults.dayKey),
            revealsToday = settings.getInt(KEY_REVEALS_TODAY, defaults.revealsToday),
        )
    }

    override fun save(state: RevealFrequencyState) {
        settings.putString(KEY_DAY, state.dayKey)
        settings.putInt(KEY_REVEALS_TODAY, state.revealsToday)
    }
}
